export const enabledDebuggers = {
  discovery: false,
  launch: false,
  sessionTracker: false,
  userAuth: false,
  snackbar: false,
  discoveryContentProvider: false,
  storeOpenBoxInfo: false,
  statusBar: false,
  notification: false,
  chat: false,
  analytics: true,
  sellerOnboarding: false,
  routes: false,
  userFront: false,
  storeFront: false,
  anyVideoClips: false,
  videoCover: false,
  mediaService: false,
  campaignTracker: false,
  linking: false,
  profile: false,
  guestCheckout: true,
  purchase: false,
  loginReminder: false,
  loginPresenter: false,
  sellerApplication: false,
  applePay: true,
  appTrackingTransparency: false, // app tracking transparency
  legacyOnboarding: false,
  commentchat: false,
  videoFeeds: false,
  mediaPlayback: false,
  navigation: false,
  shopping: false,
  onboarding: false,
  replayPlayer: false,
  continuousOnboarding: false,
  csAttribution: false,
  admin: false,
  publicResponsePreviewModal: false,
  checkout: true,
  subscribe: true,
  saasSubscription: true,
  post: true,
  tipping: true,
  bio: true,
};

export const isDebugEnabled = (name: keyof typeof enabledDebuggers) =>
  __DEV__ && enabledDebuggers[name];
